import { z } from 'zod';

/** A member's role within one organization. Read by `RolesGuard`. */
export const USER_ROLES = ['admin', 'member', 'viewer'] as const;

export type UserRole = (typeof USER_ROLES)[number];

export const userRoleSchema = z.enum(USER_ROLES);
